import courseFree from './course/free'
import userLevel from './user/level'
import userHome from './user/home'

export default {
  courseFree,
  userLevel,
  userHome,
}
